import type { Template } from "@/types";

export const PO_05_H1_V4: Template[] = [
    {
        id: "po-05-h1v4-01",
        name: "PO 01 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_01.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 43, y: 219, width: 540, height: 345, rotation: 0, imageRotation: 0 },
            { id: "2", x: 761, y: 143, width: 175, height: 245, rotation: 0, imageRotation: 0 },
            { id: "3", x: 761, y: 395, width: 175, height: 245, rotation: 0, imageRotation: 0 },
            { id: "4", x: 943, y: 143, width: 175, height: 245, rotation: 0, imageRotation: 0 },
            { id: "5", x: 943, y: 395, width: 175, height: 245, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h1v4-02",
        name: "PO 02 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_02.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 43, y: 219, width: 540, height: 345, rotation: 0, imageRotation: 0 },
            { id: "2", x: 676, y: 106, width: 385, height: 571, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1068, y: 106, width: 133, height: 185, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1068, y: 298, width: 133, height: 185, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1068, y: 491, width: 133, height: 185, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h1v4-03",
        name: "PO 03 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_03.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 60, y: 112, width: 505, height: 315, rotation: 0, imageRotation: 0 },
            { id: "2", x: 60, y: 433, width: 164, height: 239, rotation: 0, imageRotation: 0 },
            { id: "3", x: 231, y: 433, width: 163, height: 239, rotation: 0, imageRotation: 0 },
            { id: "4", x: 402, y: 433, width: 163, height: 239, rotation: 0, imageRotation: 0 },
            { id: "5", x: 715, y: 87, width: 447, height: 597, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h1v4-04",
        name: "PO 04 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_04.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 54, y: 173, width: 284, height: 438, rotation: 0, imageRotation: 0 },
            { id: "2", x: 345, y: 173, width: 228, height: 142, rotation: 0, imageRotation: 0 },
            { id: "3", x: 345, y: 321, width: 228, height: 290, rotation: 0, imageRotation: 0 },
            { id: "4", x: 687, y: 216, width: 247, height: 350, rotation: 0, imageRotation: 0 },
            { id: "5", x: 941, y: 216, width: 247, height: 350, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h1v4-05",
        name: "PO 05 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_05.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 64, y: 216, width: 247, height: 350, rotation: 0, imageRotation: 0 },
            { id: "2", x: 318, y: 216, width: 247, height: 350, rotation: 0, imageRotation: 0 },
            { id: "3", x: 679, y: 173, width: 284, height: 438, rotation: 0, imageRotation: 0 },
            { id: "4", x: 970, y: 173, width: 228, height: 290, rotation: 0, imageRotation: 0 },
            { id: "5", x: 970, y: 468, width: 228, height: 142, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h1v4-06",
        name: "PO 06 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_06.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 97, y: 92, width: 430, height: 598, rotation: 0, imageRotation: 0 },
            { id: "2", x: 679, y: 352, width: 519, height: 316, rotation: 0, imageRotation: 0 },
            { id: "3", x: 679, y: 115, width: 169, height: 231, rotation: 0, imageRotation: 0 },
            { id: "4", x: 855, y: 115, width: 169, height: 231, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1031, y: 115, width: 168, height: 231, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h1v4-07",
        name: "PO 07 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_07.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 29, y: 129, width: 179, height: 259, rotation: 0, imageRotation: 0 },
            { id: "2", x: 29, y: 395, width: 179, height: 258, rotation: 0, imageRotation: 0 },
            { id: "3", x: 215, y: 129, width: 179, height: 259, rotation: 0, imageRotation: 0 },
            { id: "4", x: 215, y: 395, width: 179, height: 258, rotation: 0, imageRotation: 0 },
            { id: "5", x: 401, y: 129, width: 821, height: 524, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h1v4-08",
        name: "PO 08 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_08.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 207, width: 594, height: 369, rotation: 0, imageRotation: 0 },
            { id: "2", x: 601, y: 207, width: 254, height: 369, rotation: 0, imageRotation: 0 },
            { id: "3", x: 863, y: 207, width: 128, height: 181, rotation: 0, imageRotation: 0 },
            { id: "4", x: 863, y: 395, width: 128, height: 181, rotation: 0, imageRotation: 0 },
            { id: "5", x: 998, y: 207, width: 254, height: 369, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h1v4-09",
        name: "PO 09 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_09.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 207, width: 594, height: 369, rotation: 0, imageRotation: 0 },
            { id: "2", x: 601, y: 207, width: 254, height: 369, rotation: 0, imageRotation: 0 },
            { id: "3", x: 863, y: 207, width: 254, height: 369, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1124, y: 207, width: 128, height: 181, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1124, y: 395, width: 128, height: 181, rotation: 0, imageRotation: 0 }
        ],
    }
];